import ActionTypes from './types';


export const addToToaster = (toaster) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.ADD_TOASTER_MESSAGE,
      toaster
    });
  };
};

export const removeToaster = (id) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.DELETE_TOASTER_MESSAGE_BY_ID,
      id
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/toasters.js